import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import showNotification from '../../components/Notification';
// import { get } from 'lodash';
import { RootState } from '.';
import { AppThunk } from '..';
import {
  getParentApi,
  getParentDetailApi,
  updateParentApi,
  getChildrenDetailApi,
  updateChildApi,
  deleteChildApi,
} from '../../api';
import { setLoading } from './commonSlice';

// TODO: create a custom thunk to handle all the request

export interface UserType {
  cognito_user_id?: string;
  created_at?: string;
  date_of_birth?: string;
  email?: string;
  first_name?: string;
  id?: string;
  last_name?: string;
  updated_at?: string;
  parent_id?: string;
  notes?: string;
}

interface ParentType extends UserType {
  children?: Array<UserType>;
}

interface HomeState {
  parent: ParentType;
  children: Array<UserType>;
  currentChild: UserType;
  users: Array<UserType>;
}

const initialState: HomeState = {
  parent: {},
  children: [],
  currentChild: {},
  users: [],
};

type ChildrenPayload = {
  children: Array<UserType>;
  parent: ParentType;
};

type CurrentChildPayload = {
  kid: UserType;
};

type GetUserPayload = {
  success?: boolean;
  data: Array<UserType>;
};

type DeleteChild = {
  id?: string;
};

const homeSlice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    getChildSuccess(state, action: PayloadAction<ChildrenPayload>) {
      return {
        ...state,
        children: action.payload.children,
        parent: action.payload.parent,
      };
    },
    getChildFailed(state) {
      return { ...state, children: [] };
    },
    setCurrentChild(state, action: PayloadAction<CurrentChildPayload>) {
      return { ...state, currentChild: action.payload.kid };
    },
    getUserSuccess(state, action: PayloadAction<GetUserPayload>) {
      return { ...state, users: action.payload.data };
    },
    getParentSuccess(state, action: PayloadAction<ParentType>) {
      return { ...state, parent: action.payload };
    },
    deleteChild(state, action: PayloadAction<DeleteChild>) {
      return { ...state, ...action };
    },
  },
});

// selector stuff
export const selectChildren = createSelector(
  (state: RootState) => state.homeReducer,
  (homeReducer: HomeState) => homeReducer.parent?.children,
);

export const selectParent = createSelector(
  (state: RootState) => state.homeReducer,
  (homeReducer: HomeState) => homeReducer.parent,
);

export const selectUsers = createSelector(
  (state: RootState) => state.homeReducer,
  (homeReducer: HomeState) => homeReducer.users,
);

export const selectCurrentChild = createSelector(
  (state: RootState) => state.homeReducer,
  (homeReducer: HomeState) => homeReducer.currentChild,
);

export const selectParentGreeting = createSelector(
  (state: RootState) => state.homeReducer,
  (homeReducer: HomeState) => homeReducer.parent.first_name,
);

export const {
  getChildSuccess,
  getChildFailed,
  setCurrentChild,
  getUserSuccess,
  getParentSuccess,
  deleteChild,
} = homeSlice.actions;

export const getUser = (): AppThunk => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const results = await getParentApi();
    dispatch(getUserSuccess({ data: results.data }));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    showNotification({
      type: 'error',
      message: 'Somethings went wrong, please try again',
    });
  }
};

export const getParentDetail = (parentId?: string): AppThunk => async (
  dispatch,
) => {
  try {
    dispatch(setLoading(true));
    const res = await getParentDetailApi(parentId);
    dispatch(getParentSuccess(res.data));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    showNotification({
      type: 'error',
      message: 'Somethings went wrong, please try again',
    });
  }
};

export const deleteChilren = (
  id?: string,
  parentId?: string,
): AppThunk => async (dispatch) => {
  // delete children
  try {
    dispatch(setLoading(true));
    await deleteChildApi(parentId, id);
    dispatch(getParentDetail(parentId));
    dispatch(setLoading(false));
    showNotification({
      type: 'success',
      message: 'Deleted account successfully',
    });
  } catch (error) {
    dispatch(setLoading(false));
    showNotification({
      type: 'error',
      message: 'Somethings went wrong, please try again',
    });
  }
};

export const updateParent = (
  params: any,
  parentId?: string,
): AppThunk => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    await updateParentApi(params, parentId);
    showNotification({
      type: 'success',
      message: 'Updated account successfully',
    });
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    showNotification({
      type: 'error',
      message: 'Somethings went wrong, please try again',
    });
  }
};

export const getCurrentChild = (
  childId?: string,
  parentId?: string,
): AppThunk => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await getChildrenDetailApi(parentId, childId);
    dispatch(setCurrentChild({ kid: response.data }));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    showNotification({
      type: 'error',
      message: 'Somethings went wrong, please try again',
    });
  }
};

export const updateChild = (
  childId: string,
  parentId: string,
  params: any,
): AppThunk => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    await updateChildApi(childId, parentId, params);
    dispatch(setLoading(false));
    showNotification({
      type: 'success',
      message: 'Updated account successfully',
    });
  } catch (erorr) {
    dispatch(setLoading(false));
    showNotification({
      type: 'error',
      message: 'Somethings went wrong, please try again',
    });
  }
};

export default homeSlice.reducer;
